module.exports = __webpack_public_path__ + "static/media/30_A.8f0f73c0.png";